import type { TApplicantPriorityDTO, TApplicantScoreDTO } from './scoring.dto';

import type { TApplicantPriority, TApplicantScore } from './scoring.types';

const toApplicantScore = (dto: TApplicantScoreDTO): TApplicantScore => ({
  applicantID: dto.id,
  qualityScore: dto.quality_score,
  archetype: dto.archetype,
  updatedAt: dto.updated_at,
  updatedBy: dto.updated_by,
});

const toApplicantPriority = (dto: TApplicantPriorityDTO): TApplicantPriority => ({
  applicantID: dto.user_id ?? '',
  qualityScore: dto.quality_score,
  interviewBoost: dto.interview_boost ?? 0,
  validationBoost: dto.validation_boost ?? 0,
  finalPriority: dto.final_priority,
});

export {
  toApplicantPriority,
  toApplicantScore,
};
